import { render, staticRenderFns } from "./MapDrawerLayerStats.vue?vue&type=template&id=c454bd96&scoped=true&"
import script from "./MapDrawerLayerStats.vue?vue&type=script&lang=js&"
export * from "./MapDrawerLayerStats.vue?vue&type=script&lang=js&"
import style0 from "./MapDrawerLayerStats.vue?vue&type=style&index=0&id=c454bd96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c454bd96",
  null
  
)

export default component.exports